'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reduxForm = require('redux-form');

var _api = require('./api');

var _api2 = _interopRequireDefault(_api);

var _application = require('./application');

var _application2 = _interopRequireDefault(_application);

var _msh = require('./msh');

var _msh2 = _interopRequireDefault(_msh);

var _navigation = require('./navigation');

var _navigation2 = _interopRequireDefault(_navigation);

var _formConfig = require('./formConfig');

var _formConfig2 = _interopRequireDefault(_formConfig);

var _savedQuote = require('./savedQuote');

var _savedQuote2 = _interopRequireDefault(_savedQuote);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  api: _api2.default,
  application: _application2.default,
  msh: _msh2.default,
  navigation: _navigation2.default,
  form: _reduxForm.reducer,
  formConfig: _formConfig2.default,
  savedQuote: _savedQuote2.default
});


//////////////////
// WEBPACK FOOTER
// ./src/v2/reducers/rootReducer.js
// module id = 1733
// module chunks = 0